import React, { useState, useEffect } from 'react';

export const useNightModeStyles = () => {
  const [isNightHours, setIsNightHours] = useState(() => {
    const hour = new Date().getHours();
    return hour >= 20 || hour < 4; // 20:00 to 03:59
  });

  useEffect(() => {
    const checkNightHours = () => {
      const hour = new Date().getHours();
      const nightTime = hour >= 20 || hour < 4;
      setIsNightHours(nightTime);
      console.log('Night mode check:', hour, 'is night time:', nightTime);
    };

    // Check immediately
    checkNightHours();

    // Set up interval to check every minute (in case we transition during usage)
    const interval = setInterval(checkNightHours, 60000);

    return () => clearInterval(interval);
  }, []);

  return {
    isNightHours,
    // Return classes that override light mode with dark styles during night hours
    getNightModeClass: () => isNightHours ? 'night-mode-override' : ''
  };
};